export const CARE_MANAGER_HIDE_NAVBAR_PREFIXES = ["/care-manager", "/care-manager/messenger"];

/** `requiresWorkspace: false` items stay visible while onboarding / subscription-locked. */
export const CARE_MANAGER_SIDEBAR_ITEMS = [
  { to: "/care-manager/onboarding", label: "Onboarding status", icon: "shield", requiresWorkspace: false },
  { to: "/care-manager/documents", label: "Documents", icon: "document", requiresWorkspace: false },
  { to: "/care-manager/profile", label: "Clinical profile", icon: "user", requiresWorkspace: false },
  { to: "/care-manager/subscription", label: "Subscription", icon: "shield", requiresWorkspace: false },
  { to: "/care-manager/dashboard", label: "Dispatcher hub", icon: "home", requiresWorkspace: true },
  { to: "/care-manager", label: "My cases", end: true, icon: "list", requiresWorkspace: true },
  { to: "/care-manager/messenger", label: "Messenger", icon: "message", requiresWorkspace: true },
  { to: "/care-manager/assessments", label: "Assessments", icon: "document", requiresWorkspace: true },
  { to: "/care-manager/care-plans", label: "Care plans", icon: "list", requiresWorkspace: true },
  { to: "/care-manager/marketplace", label: "Marketplace", icon: "search", requiresWorkspace: true },
  { to: "/care-manager/care-logs", label: "Care logs", icon: "clock", requiresWorkspace: true },
  { to: "/care-manager/emergency-requests", label: "Emergency Requests", icon: "alert", requiresWorkspace: true },
  { to: "/care-manager/exceptions", label: "Exceptions", icon: "alert", requiresWorkspace: true },
  { to: "/care-manager/replacements", label: "Replacements", icon: "alert", requiresWorkspace: true },
];

export function filterCareManagerSidebarItems(items, workspaceUnlocked) {
  if (workspaceUnlocked) return items;
  return items.filter((item) => !item.requiresWorkspace);
}

export const CARE_MANAGER_USER_META = {
  initials: "",
  name: "",
  role: "Care Manager",
};
